import { FC } from 'react';
import { TableStyled } from './style';

const Table: FC = ({ children, ...restProps }) => <TableStyled {...restProps}>{children}</TableStyled>;

export default Table;
